import { GeographicAreaShape } from "./api/Representation";
import {} from "../../../api/Representation";
export class MapAreaShapeTransformer {
    static fromResponse(response) {
        if (response.shape == GeographicAreaShape.CIRCLE) {
            return MapAreaShapeTransformer.fromCircleResponse(response);
        }
        if (response.shape == GeographicAreaShape.RECTANGLE) {
            return MapAreaShapeTransformer.fromRectangleResponse(response);
        }
        return MapAreaShapeTransformer.fromPolygonResponse(response);
    }
    static fromCircleResponse(response) {
        return {
            id: response.id,
            version: response.version,
            key: `circle-${response.id}`,
            divisionId: response.division?.id,
            title: response.title,
            shape: response.shape,
            center: {
                lat: response.centerLat,
                lng: response.centerLng,
            },
            priority: response.priority,
            disabledAt: response.disabledAt,
            colourHex: response.colourHex,
            radius: response.radiusMetres
        };
    }
    static fromRectangleResponse(response) {
        return {
            id: response.id,
            version: response.version,
            key: `rect-${response.id}`,
            divisionId: response.division?.id,
            title: response.title,
            shape: response.shape,
            center: {
                lat: response.centerLat,
                lng: response.centerLng,
            },
            priority: response.priority,
            disabledAt: response.disabledAt,
            colourHex: response.colourHex,
            bounds: {
                north: response.northLat,
                east: response.eastLng,
                south: response.southLat,
                west: response.westLng
            }
        };
    }
    static fromPolygonResponse(response) {
        return {
            id: response.id,
            version: response.version,
            key: `polygon-${response.id}`,
            divisionId: response.division?.id,
            title: response.title,
            shape: response.shape,
            center: {
                lat: response.centerLat,
                lng: response.centerLng,
            },
            priority: response.priority,
            disabledAt: response.disabledAt,
            colourHex: response.colourHex,
            path: response.coords
        };
    }
    static toUpdateRequest(shape, tenantId, divisionId, title, priority, colourHex, version, disabledAt) {
        if (shape.shape == GeographicAreaShape.CIRCLE) {
            return MapAreaShapeTransformer.toCircleUpdateRequest(shape, tenantId, divisionId, title, priority, colourHex, version, disabledAt);
        }
        if (shape.shape == GeographicAreaShape.RECTANGLE) {
            return MapAreaShapeTransformer.toRectangleUpdateRequest(shape, tenantId, divisionId, title, priority, colourHex, version, disabledAt);
        }
        return MapAreaShapeTransformer.toPolygonUpdateRequest(shape, tenantId, divisionId, title, priority, colourHex, version, disabledAt);
    }
    static toCircleUpdateRequest(circle, tenantId, divisionId, title, priority, colourHex, version, disabledAt) {
        return {
            shape: GeographicAreaShape.CIRCLE,
            tenantId,
            divisionId,
            title,
            priority,
            colourHex,
            centerLat: circle.center.lat,
            centerLng: circle.center.lng,
            version,
            disabledAt,
            radiusMetres: circle.radius
        };
    }
    static toRectangleUpdateRequest(rect, tenantId, divisionId, title, priority, colourHex, version, disabledAt) {
        return {
            shape: GeographicAreaShape.RECTANGLE,
            tenantId,
            divisionId,
            title,
            priority,
            colourHex,
            version,
            disabledAt,
            centerLat: rect.center.lat,
            centerLng: rect.center.lng,
            northLat: rect.bounds.north,
            eastLng: rect.bounds.east,
            southLat: rect.bounds.south,
            westLng: rect.bounds.west
        };
    }
    static toPolygonUpdateRequest(polygon, tenantId, divisionId, title, priority, colourHex, version, disabledAt) {
        return {
            shape: GeographicAreaShape.POLYGON,
            tenantId,
            divisionId,
            title,
            priority,
            colourHex,
            version,
            disabledAt,
            centerLat: polygon.center.lat,
            centerLng: polygon.center.lng,
            coords: polygon.path.map((latLng, index) => {
                return {
                    sequence: index,
                    lat: latLng.lat,
                    lng: latLng.lng
                };
            })
        };
    }
}
